import React from "react";

function ArrowDown({ deg }) {
  return (
    <>
      <svg
        width={16}
        height={16}
        fill="none"

        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${deg}deg)`, transition: "all .3s" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
          fill="currentColor"
          />
      </svg>
    </>
  );
}

export default ArrowDown;
